import { Component, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AppState } from '../../../app/app.service';
import { ClientUtilities } from './utils/client-utils';

@Component({
    selector: 'app',
    encapsulation: ViewEncapsulation.None,
    styles: [require('./publisher.scss')],
    templateUrl: './publisher.component.html',
})

export class PublisherApp {

    private isVsphereClient: boolean = false;

    constructor(public appState: AppState, public router: Router,
                private titleService: Title) {
    }

    public ngOnInit() {
        const path = (window.location.pathname.match(/(.*)(\/publisher-ui)(\/.*|$)/) || [])[1];
        this.isVsphereClient = !!path && ClientUtilities.runningInPluginUI();
    }

    public setTitle(newTitle: string) {
        const title = this.titleService.getTitle();
        this.titleService.setTitle(`${title} - ${newTitle}`);
    }

    public logout() {
        // this.authService.logout();
        this.router.navigate(['/login']);
    }

}



// WEBPACK FOOTER //
// ./src/publisher/src/publisher-ui/publisher.component.ts